module.exports = __webpack_public_path__ + "static/scraper-ba626c31e8ddd956979b90cc308803a6.png";